<template>
  <b-form-group>
    <h6 class="mb-1 font-size-md">
      <span
        v-if="required"
        class="text-danger ml-n1"
      >*</span>
      {{ $t("global.address") }}
    </h6>
    <b-form-input
      v-model="currentAnswer"
      :disabled="!editable && answer !== '' && !shouldEdit"
      class="w-100"
      :placeholder="$t('global.please-enter') + $t('global.address')"
      type="text"
      maxlength="100"
      :state="validateState"
    />
    <b-form-invalid-feedback :state="validateState">
      {{
        $t("global.please-enter-required")
      }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    question: {
      type: String,
    },
    options: {
      type: Array,
    },
    answer: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    editable: {
      type: Boolean,
    },
  },
  data() {
    return {
      shouldEdit: true,
      validateState: undefined,
    };
  },
  computed: {
    currentAnswer: {
      get() {
        return this.answer;
      },
      set(value) {
        this.$emit('update:answer', value);
      },
    },
  },
  watch: {
    currentAnswer() {
      this.validate();
    },
  },
  created() {
    if (this.answer !== '') {
      this.shouldEdit = false;
    }
  },
  methods: {
    validate() {
      if (this.required) {
        if (this.currentAnswer) {
          this.validateState = true;
          return true;
        }
        this.validateState = false;
        return false;
      }
      this.validateState = true;
      return true;
    },
  },
};
</script>
